// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-view-layout {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two equal columns */
  gap: 2rem; /* Spacing between the two sections */
  max-width: 90%; /* Restrict the layout width */
  margin: 0 auto; /* Center align the layout */
  padding: 2rem; /* Add some space around the layout */
}

@media (min-width: 1200px) {
  .patient-view-layout {
    /* max-width: 1500px;  */
    max-width: 90%; 
  }
}

@media (max-width: 768px) {
  .patient-view-layout {
    grid-template-columns: 1fr; /* Stack vertically on smaller screens */
  }
}

.sched-patient-name {
  margin-bottom: 20px;
  animation: fadeIn 0.6s ease-in-out; 
}

.sched-patient-name label {
  display: block;
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--clr-primary-5);
  margin-bottom: 8px;
  transition: color 0.3s ease-in-out; 
}

.sched-patient-name input {
  width: 100%;
  padding: 12px; 
  font-size: 1.1rem; 
  border: 1px solid var(--grey-300);
  border-radius: var(--borderRadius);
  background-color: var(--grey-100); 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
  transition: border-color 0.3s ease, background-color 0.3s ease;
}

.sched-patient-name input:focus {
  outline: none;
  border-color: var(--clr-primary-5); 
  background-color: var(--clr-white); 
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.2); 
}

.sched-patient-name input::placeholder {
  color: var(--grey-500); 
  /* font-style: italic; */
  transition: color 0.3s ease-in-out; 
}

.sched-patient-view-container {
  padding: 2.5rem;
  background-color: var(--clr-grey-10);
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-3); 
  max-width: none; 
  margin:0;
  width: 100%;
  font-family: var(--ff-primary);
  color: var(--textColor);
  animation: slideUp 0.8s ease-out; 
}

.sched-patient-view-container,
.info-display-container {
  margin: 0; /* Remove any default margins */
  width: 100%; /* Ensure they fill their column */
}


.sched-section-container {
  background-color: var(--clr-background);
  padding: 2rem;
  border-radius: var(--borderRadius);
  margin-bottom: 2rem;
  box-shadow: var(--shadow-1);
  border: 2px solid var(--clr-primary-5);
}

.sched-discipline-select,
.sched-doctor-select,
.sched-time-slot-select {
  margin-bottom: 1.5rem;
}

.sched-select {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid var(--grey-300);
  border-radius: var(--borderRadius);
  font-size: 1rem;
  background-color: var(--grey-100);
  color: var(--textColor);
  transition: var(--transition);
}

.sched-select:hover,
.sched-select:focus {
  border-color: var(--clr-primary-5);
  background-color: var(--grey-200);
}

.sched-h3 {
  font-size: 1.4rem;
  color: var(--grey-700);
  margin-bottom: 1rem;
}

.sched-ul {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); 
  gap: 0.5rem; 
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.sched-ul li {
  padding: 0.5rem;
  margin: 0;
  border: 1px solid var(--clr-primary-3);
  border-radius: var(--borderRadius);
  background-color: var(--clr-primary-9);
  font-size: 0.9rem;
  color: var(--clr-primary-1);
  text-align: center;
  transition: background-color 0.3s ease, transform 0.2s ease;
  cursor: pointer; /* Add cursor pointer for interactable slots */
}

.sched-ul li:hover {
  background-color: var(--clr-primary-7);
  transform: scale(1.05);
}

.sched-ul li.sched-past-time {
  background-color: var(--grey-200);
  color: var(--grey-600);
  cursor: not-allowed; /* Show disabled cursor for past slots */
}

.sched-ul li.sched-past-time:hover {
  background-color: var(--grey-300);
  transform: none;
}

.sched-ul li.selected-slot {
  background-color: var(--red-light); /* Highlight selected slot */
  color: var(--clr-grey-1); /* Change text color for better contrast */
  border: 2px solid var(--clr-primary-7); /* Add a more prominent border */
}

.sched-ul li.selected-slot:hover {
  background-color: var(--clr-primary-4); /* Slightly darker highlight on hover */
  transform: scale(1.1); /* Slightly larger scale for selected slot hover */
}


.schedule-hint {
  font-size: 1rem;
  color: var(--grey-6);
  margin-bottom: 1rem;
}

.sched-slider {
  margin-bottom: 1rem;
  background-color: var(--grey-200);
  padding: 0.5rem;
  border-radius: var(--borderRadius);
}

.slick-prev,
.slick-next {
  background-color: var(--clr-primary-5) !important;
  border-radius: 50% !important;
  width: 30px !important;
  height: 30px !important;
  z-index: 1;
}

.slick-prev:before,
.slick-next:before {
  color: var(--clr-white) !important;
  font-size: 20px !important;
}

.slick-prev:hover,
.slick-next:hover {
  background-color: var(--clr-primary-3) !important;
}

.slick-prev {
  left: -40px !important;
}

.slick-next {
  right: -40px !important;
}

.sched-slider-item {
  text-align: center;
  padding: 0.5rem;
}

.sched-day-button {
  padding: 1rem 1.5rem; 
  border: 2px solid var(--clr-primary-5);
  border-radius: var(--borderRadius);
  background-color: var(--clr-primary-7);
  color: var(--clr-white);
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  width: 100%;
}

.sched-day-button.disabled {
  background-color: var(--grey-300);
  color: var(--grey-600);
  pointer-events: none;
}

.sched-day-button.today {
  background-color: var(--clr-primary-6);
  font-weight: bold;
  color: var(--clr-white);
}

.sched-day-button.selected {
  background-color: var(--red-light);
  color: var(--clr-grey-1);
}

.sched-day-button:hover {
  background-color: var(--clr-primary-3);
  transform: scale(1.05); 
}

.sched-proceed-button {
  padding: 1.2rem 1.5rem; 
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
  border: none;
  border-radius: var(--borderRadius);
  font-size: 1.1rem; 
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.sched-proceed-button:hover {
  background-color: var(--clr-primary-3);
  transform: scale(1.05); 
}

.sched-instructions {
  font-size: 1rem;
  color: var(--clr-grey-5);
  margin-bottom: 1rem;
  /* text-align: center; */
}

/* Fade-in and slide-up animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive styles */
@media (max-width: 768px) {
  .sched-patient-view-container {
    padding: 1.5rem;
    /* margin: 2rem auto; */
  }

  .sched-slider-item {
    padding: 0.3rem;
  }

  .sched-day-button {
    padding: 0.8rem 1rem;
    font-size: 1rem;
  }

  .sched-proceed-button {
    font-size: 1rem;
    padding: 1rem 1.2rem;
  }
}

/* Styling for the recurring booking checkbox */
.sched-recurring-checkbox {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  color: var(--clr-primary-5);
  font-weight: bold;
}

.sched-recurring-checkbox input {
  margin-right: 10px;
  transform: scale(1.2); 
  cursor: pointer; 
}

/* Change cursor to 'not-allowed' when the checkbox is disabled */
.sched-recurring-checkbox input:disabled {
  cursor: not-allowed; 
}

.sched-recurring-checkbox input:disabled + .checkbox-label {
  color: var(--clr-grey-500); 
}

.checkbox-label {
  font-size: 1.1rem;
  margin-right: 10px;
  color: var(--clr-primary-7);
}

.sched-recurring-booking {
  margin-top: 20px;
  padding: 20px;
  background-color: var(--grey-50);
  border: 2px solid var(--clr-primary-5);
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-2); 
  transition: all 0.3s ease-in-out;
}

.sched-recurring-booking.disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Styling for recurring booking options */
.sched-recurring-options {
  margin-top: 15px;
}

.sched-recurring-label {
  font-size: 1rem;
  font-weight: bold;
  color: var(--clr-primary-7);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sched-recurring-input {
  margin-left: 0rem;
  padding: 10px;
  font-size: 1rem;
  border-radius: var(--borderRadius);
  border: 1px solid var(--grey-300);
  background-color: var(--clr-white);
  transition: border-color 0.3s ease;
}

.sched-recurring-input:focus {
  border-color: var(--clr-primary-5);
}

.recurring-row {
  margin-bottom: 15px;
}

.recurring-frequency {
  margin-left: 10px;
  font-weight: normal;
  font-size: 0.9rem;
  color: var(--grey-700);
}

.sched-recurring-select {
  padding: 10px;
  font-size: 1rem;
  border-radius: var(--borderRadius);
  border: 1px solid var(--grey-300);
  background-color: var(--grey-50);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.sched-recurring-select:hover,
.sched-recurring-select:focus {
  background-color: var(--clr-white);
  border-color: var(--clr-primary-5);
}

/* Tooltip styling */
.tooltip {
  margin-left: 8px;
  cursor: pointer;
  font-size: 1.1rem;
  color: #007BFF;
  position: relative;
}

.tooltip:hover::after {
  content: attr(title);
  position: absolute;
  left: 0;
  bottom: 100%;
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 5px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1;
  color: var(--clr-primary-7);
  font-size: 0.85rem;
  box-shadow: var(--shadow-1);
}

/* Styling for the checkbox when it is disabled */
.sched-recurring-checkbox input:checked:disabled {
  cursor: not-allowed;
  background-color: var(--clr-grey-300);
}

/* General input and button styles for consistency */
.sched-recurring-input,
.sched-recurring-select {
  width: 100%;
  margin-top: 5px;
}

.sched-recurring-options label {
  display: block;
  margin-bottom: 10px;
}

/* Hover effect for the recurring booking section */
.sched-recurring-booking:hover {
  background-color: var(--grey-100);
  border-color: var(--clr-primary-6);
  box-shadow: var(--shadow-3);
}

/* Custom Tooltip Styling */
.custom-tooltip {
  position: relative;
  padding: 10px 15px;
  background-color: var(--red-dark) ; 
  color: var(--clr-white); 
  font-size: 0.9rem;
  border-radius: 5px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); 
  animation: fadeInTooltip 0.5s ease-out;
  margin: 10px 0; 
  z-index: 10; 
  text-align: center; 
  /* max-width: 400px;  */
  word-wrap: break-word; 
}

/* Add tooltip arrow */
.custom-tooltip::after {
  content: "";
  position: absolute;
  top: 100%; 
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--red-light) transparent transparent transparent; /* Arrow pointing down */
}

/* Add subtle animation for the tooltip */
@keyframes fadeInTooltip {
  from {
    opacity: 0;
    transform: translateY(-10px); 
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Navigation Container - Text & Button  */
.sched-view-navigation {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  gap: 15px; /* Proper spacing between text and button */
  margin-top: 3rem;
  margin-bottom: 1rem;
}

/* Informational Text */
.sched-text {
  font-size: 16px;
  font-weight: 700;
  color: var(--clr-grey-1);
  white-space: nowrap; 
}

/* Previous Appointments Button  */
.sched-view-button {
  background: var(--clr-primary-5);
  color: var(--clr-white);
  padding: 12px 20px;
  /* font-size: 16px; */
  font-weight: bold;
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  transition: var(--transition);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: var(--shadow-2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -1rem;
  /* min-width: 180px;  */
}

/* Hover & Active Effects */
.sched-view-button:hover {
  background: var(--clr-primary-3);
  transform: translateY(-2px);
  box-shadow: var(--shadow-3);
}

.sched-view-button:active {
  transform: scale(0.98);
}

/* Responsive Fix: Stack Text & Button on Small Screens */
@media screen and (max-width: 768px) {
  .sched-view-navigation {
      flex-direction: column;
      text-align: center;
  }

  .sched-text {
      margin-bottom: 8px;
  }
}


/* Styles for clinic search section with alignment and responsiveness */
.clinic-search-section {
  margin: 0 auto 20px auto; 
  position: relative;
  max-width: 100%; 
  display: flex;
  flex-direction: column; 
}


.clinic-search-section label {
  display: block;
  font-size: 1.1rem; 
  font-weight: bold;
  color: var(--clr-primary-5);
  margin-bottom: 8px; 
  text-align: left;
}

.clinic-search-input {
  width: 100%;
  padding: 12px; 
  border: 1px solid var(--grey-300);
  border-radius: var(--borderRadius);
  font-size: 1.1rem; 
  background-color: var(--grey-100);
  transition: border-color 0.3s ease, background-color 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
}

.clinic-search-input:focus {
  outline: none;
  border-color: var(--clr-primary-5); 
  background-color: var(--clr-white);
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.2); 
}

/* Clinic search results dropdown */
.clinic-search-results {
  margin-top: 10px;
  border: 1px solid var(--grey-300);
  border-radius: var(--borderRadius);
  max-height: 250px; 
  overflow-y: auto; 
  background-color: var(--clr-white);
  box-shadow: var(--shadow-3); 
  padding: 0; 
}

/* Clinic search items */
.clinic-search-item {
  padding: 12px; 
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 1rem;
}

.clinic-search-item:hover {
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
}

.clinic-search-item.selected {
  background-color: var(--clr-primary-7);
  color: var(--clr-white);
}

.no-clinics-found {
  margin-top: 10px;
  font-size: 1rem;
  color: var(--red-dark);
  text-align: center; 
}

/* Responsive Styles */
@media (max-width: 768px) {
  .clinic-search-section {
    max-width: 100%; 
  }

  .clinic-search-item {
    font-size: 0.9rem; 
    padding: 10px; 
  }

  .clinic-search-results {
    max-height: 200px; 
  }

  .clinic-search-input {
    padding: 10px; 
    font-size: 1rem;
  }
}

.no-doctors-banner {
  background-color: #f8d7da; 
  color: #721c24; 
  padding: 10px;
  margin-top: 10px;
  border: 1px solid #f5c6cb; 
  border-radius: 5px;
  font-weight: bold;
  text-align: center;
}

.booked-slot-info {
  margin: 1rem 0;
  padding: 1rem;
  background-color: var(--grey-300); 
  border-left: 4px solid var(--clr-grey-3); 
  /* color: var(--red-light); */
  border-radius: 4px;
}

.booked-slot-info h4 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  font-weight: bold;
}

.booked-slot-info ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.booked-slot-info ul li {
  font-size: 0.9rem;
}

.info-display-container {
  padding: 2rem;
  background-color: var(--grey-50); 
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-2); 
  font-size: 1rem;
  color: var(--textColor); 
  animation: slideUp 0.8s ease-out; 
}

/* .info-display-container h2 {
  font-size: 1.4rem;
  color: var(--clr-primary-5); 
  margin-bottom: 1rem;
} */

.info-display-container ul {
  margin: 0;
  padding: 0;
  list-style-type: disc; 
  margin-left: 1.5rem; 
}

.info-display-container li {
  margin-bottom: 0.8rem;
}

@media (max-width: 768px) {
  .patient-view-layout {
    grid-template-columns: 1fr; 
  }

  .sched-patient-view-container,
  .info-display-container {
    padding: 1.5rem; 
  }
}

/* Timeline Container */
.vertical-timeline-container {
  /* max-width: 600px; */
  margin: 2rem auto;
  padding: 1.5rem;
  background-color: var(--clr-white);
  border: 1px solid var(--grey-300);
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-2);
}

.timeline-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--clr-primary-7);
  text-align: center;
  margin-bottom: 2rem;
}

/* Vertical Timeline */
.vertical-timeline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

/* Step Styling */
.timeline-step {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  position: relative;
}

.timeline-marker {
  width: 40px;
  height: 40px;
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  z-index: 1;
  flex-shrink: 0;
}

.timeline-content {
  margin-left: 1.5rem;
  text-align: left;
}

.timeline-step-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: var(--clr-grey-5);
  margin-bottom: 0.5rem;
}

.timeline-step-description {
  font-size: 0.9rem;
  color: var(--clr-grey-2);
  line-height: 1.4;
}


/* Responsive Styling */
@media (max-width: 768px) {
  .vertical-timeline-container {
    padding: 1rem;
  }

  .timeline-title {
    font-size: 1.3rem;
  }

  .timeline-marker {
    width: 30px;
    height: 30px;
    font-size: 1rem;
  }

  .timeline-content {
    margin-left: 1rem;
  }

  .timeline-step-title {
    font-size: 1rem;
  }

  .timeline-step-description {
    font-size: 0.85rem;
  }
}



/* Practitioner List Container */
/* .info-practitioner-list {
  margin-top: 2rem;
  text-align: left;
} */
/* Section 2 - Practitioner List */
.info-practitioner-list {
  padding: 2rem;
  background-color: var(--clr-white);
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-1);
  border: 2px solid var(--clr-primary-3); 
}

.info-practitioner-title {
  font-size: 1.2rem; 
  color: var(--clr-primary-5);
  margin-bottom: 1rem;
  font-weight: bold;
}

/* Practitioner Cards Grid */
.info-practitioner-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); 
  gap: 1rem; 
}

/* Practitioner Card */
.info-practitioner-card {
  background-color: var(--clr-white);
  border: 1px solid var(--grey-300);
  border-radius: var(--borderRadius);
  padding: 0.8rem;
  box-shadow: var(--shadow-1);
  display: flex;
  flex-direction: column;
  justify-content: space-between; 
  align-items: center;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  /* Added height properties */
  min-height: 250px; 
  height: auto; 
  max-height: 400px; 
}

.info-practitioner-card:hover {
  transform: scale(1);
  box-shadow: var(--shadow-3);
}

/* Practitioner Image */
.info-practitioner-image {
  width: 5rem !important; 
  height: 5rem;
  border-radius: 50%;
  margin-bottom: 0.5rem;
  object-fit: cover; 
}

/* Practitioner Details */
.info-practitioner-details {
  width: 100%; 
  margin-top: auto; 
  font-size: 0.85rem; 
}

/* Practitioner Row */
.info-practitioner-row {
  display: flex;
  align-items: center; 
  justify-content: space-between; 
  gap: 1rem; 
  font-size: 0.9rem; 
  color: var(--clr-grey-7); 
}

/* Individual Fields */
.info-practitioner-specialization,
.info-practitioner-license {
  margin: 0; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  color: var(--clr-grey-2);
}

/* Practitioner Header */
.info-practitioner-header {
  display: flex;
  align-items: center; 
  justify-content: space-between; 
  gap: 1rem; 
  font-size: 1rem; 
  color: var(--clr-grey-9); 
}

/* Name Field */
.info-practitioner-name {
  font-size: 1rem; 
  font-weight: bold; 
  margin: 0; 
  /* flex-grow: 1;  */
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  color: var(--clr-accent);
}

/* Phone Field */
.info-practitioner-phone {
  font-size: 0.9rem; 
  margin: 0; 
  white-space: nowrap; 
  color: var(--clr-grey-1); 
}

/* No Practitioners Placeholder */
.info-no-practitioners {
  font-size: 0.9rem;
  color: var(--red-light);
  text-align: center;
}

/* Default Placeholder Message */
.info-default-message {
  font-size: 0.9rem;
  color: var(--clr-grey-7);
  text-align: center;
  padding: 1rem;
  background-color: var(--grey-50);
  border-radius: var(--borderRadius);
  border: 1px dashed var(--clr-primary-5);
  animation: fadeIn 0.6s ease;
}

/* Scrollable Container */
.scrollable-container {
  max-height: 30rem; 
  overflow-y: auto;
  padding-right: 0.5rem;
}

.scrollable-container::-webkit-scrollbar {
  width: 0.4rem;
}

.scrollable-container::-webkit-scrollbar-thumb {
  background-color: var(--clr-primary-5);
  border-radius: var(--borderRadius);
}

.scrollable-container::-webkit-scrollbar-thumb:hover {
  background-color: var(--clr-primary-7);
}


/* Responsive Styles */
@media (max-width: 768px) {
  /* Adjust card grid for smaller screens */
  .info-practitioner-cards {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 0.8rem; /* Reduced gap */
  }

  /* Practitioner Card */
  .info-practitioner-card {
    padding: 0.6rem; 
  }

  .info-practitioner-image {
    width: 4rem;
    height: 4rem; 
  }

  .info-practitioner-details {
    font-size: 0.75rem; 
  }

  .info-practitioner-name {
    font-size: 0.85rem;
  }

  /* Adjust Scrollable Height */
  .scrollable-container {
    max-height: 15rem;
  }
}

@media (max-width: 480px) {
  /* Single Column for Very Small Screens */
  .info-practitioner-cards {
    grid-template-columns: 1fr;
  }

  .info-practitioner-image {
    width: 3.5rem;
    height: 3.5rem; 
  }

  .info-practitioner-name {
    font-size: 0.8rem;
  }

  .info-practitioner-details {
    font-size: 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/PatientView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B,EAAE,sBAAsB;EACtD,SAAS,EAAE,qCAAqC;EAChD,cAAc,EAAE,8BAA8B;EAC9C,cAAc,EAAE,4BAA4B;EAC5C,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE;IACE,wBAAwB;IACxB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,0BAA0B,EAAE,wCAAwC;EACtE;AACF;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,iCAAiC;EACjC,kCAAkC;EAClC,iCAAiC;EACjC,wCAAwC;EACxC,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,QAAQ;EACR,WAAW;EACX,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,SAAS,EAAE,+BAA+B;EAC1C,WAAW,EAAE,kCAAkC;AACjD;;;AAGA;EACE,uCAAuC;EACvC,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;EAEE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,sCAAsC;EACtC,kCAAkC;EAClC,sCAAsC;EACtC,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,2DAA2D;EAC3D,eAAe,EAAE,8CAA8C;AACjE;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kCAAkC,EAAE,4BAA4B;EAChE,wBAAwB,EAAE,0CAA0C;EACpE,sCAAsC,EAAE,gCAAgC;AAC1E;;AAEA;EACE,sCAAsC,EAAE,uCAAuC;EAC/E,qBAAqB,EAAE,kDAAkD;AAC3E;;;AAGA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,iDAAiD;EACjD,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;EAEE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;EACtC,kCAAkC;EAClC,sCAAsC;EACtC,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,8DAA8D;AAChE;;AAEA;;EAEE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,oDAAoD;AACpD;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,sCAAsC;EACtC,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kEAAkE,EAAE,wBAAwB;AAC9F;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS,EAAE,2CAA2C;EACtD,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE;MACI,sBAAsB;MACtB,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;EACtB;AACF;;;AAGA,uEAAuE;AACvE;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,kCAAkC;EAClC,iBAAiB;EACjB,iCAAiC;EACjC,8DAA8D;EAC9D,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iCAAiC;EACjC,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;;;GAIG;;AAEH;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;;AAGA,uBAAuB;AACvB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;;AAIA,gCAAgC;AAChC;;;GAGG;AACH,kCAAkC;AAClC;EACE,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;;EAErD,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;;EAEE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,kCAAkC;EAClC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;;AAGA,sBAAsB;AACtB;EACE,yCAAyC;EACzC;IACE,2DAA2D;IAC3D,WAAW,EAAE,gBAAgB;EAC/B;;EAEA,sBAAsB;EACtB;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,6BAA6B;EAC7B;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yCAAyC;EACzC;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".patient-view-layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Two equal columns */\n  gap: 2rem; /* Spacing between the two sections */\n  max-width: 90%; /* Restrict the layout width */\n  margin: 0 auto; /* Center align the layout */\n  padding: 2rem; /* Add some space around the layout */\n}\n\n@media (min-width: 1200px) {\n  .patient-view-layout {\n    /* max-width: 1500px;  */\n    max-width: 90%; \n  }\n}\n\n@media (max-width: 768px) {\n  .patient-view-layout {\n    grid-template-columns: 1fr; /* Stack vertically on smaller screens */\n  }\n}\n\n.sched-patient-name {\n  margin-bottom: 20px;\n  animation: fadeIn 0.6s ease-in-out; \n}\n\n.sched-patient-name label {\n  display: block;\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: var(--clr-primary-5);\n  margin-bottom: 8px;\n  transition: color 0.3s ease-in-out; \n}\n\n.sched-patient-name input {\n  width: 100%;\n  padding: 12px; \n  font-size: 1.1rem; \n  border: 1px solid var(--grey-300);\n  border-radius: var(--borderRadius);\n  background-color: var(--grey-100); \n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \n  transition: border-color 0.3s ease, background-color 0.3s ease;\n}\n\n.sched-patient-name input:focus {\n  outline: none;\n  border-color: var(--clr-primary-5); \n  background-color: var(--clr-white); \n  box-shadow: 0 0 10px rgba(0, 123, 255, 0.2); \n}\n\n.sched-patient-name input::placeholder {\n  color: var(--grey-500); \n  /* font-style: italic; */\n  transition: color 0.3s ease-in-out; \n}\n\n.sched-patient-view-container {\n  padding: 2.5rem;\n  background-color: var(--clr-grey-10);\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-3); \n  max-width: none; \n  margin:0;\n  width: 100%;\n  font-family: var(--ff-primary);\n  color: var(--textColor);\n  animation: slideUp 0.8s ease-out; \n}\n\n.sched-patient-view-container,\n.info-display-container {\n  margin: 0; /* Remove any default margins */\n  width: 100%; /* Ensure they fill their column */\n}\n\n\n.sched-section-container {\n  background-color: var(--clr-background);\n  padding: 2rem;\n  border-radius: var(--borderRadius);\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-1);\n  border: 2px solid var(--clr-primary-5);\n}\n\n.sched-discipline-select,\n.sched-doctor-select,\n.sched-time-slot-select {\n  margin-bottom: 1.5rem;\n}\n\n.sched-select {\n  width: 100%;\n  padding: 0.8rem;\n  border: 1px solid var(--grey-300);\n  border-radius: var(--borderRadius);\n  font-size: 1rem;\n  background-color: var(--grey-100);\n  color: var(--textColor);\n  transition: var(--transition);\n}\n\n.sched-select:hover,\n.sched-select:focus {\n  border-color: var(--clr-primary-5);\n  background-color: var(--grey-200);\n}\n\n.sched-h3 {\n  font-size: 1.4rem;\n  color: var(--grey-700);\n  margin-bottom: 1rem;\n}\n\n.sched-ul {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); \n  gap: 0.5rem; \n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sched-ul li {\n  padding: 0.5rem;\n  margin: 0;\n  border: 1px solid var(--clr-primary-3);\n  border-radius: var(--borderRadius);\n  background-color: var(--clr-primary-9);\n  font-size: 0.9rem;\n  color: var(--clr-primary-1);\n  text-align: center;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  cursor: pointer; /* Add cursor pointer for interactable slots */\n}\n\n.sched-ul li:hover {\n  background-color: var(--clr-primary-7);\n  transform: scale(1.05);\n}\n\n.sched-ul li.sched-past-time {\n  background-color: var(--grey-200);\n  color: var(--grey-600);\n  cursor: not-allowed; /* Show disabled cursor for past slots */\n}\n\n.sched-ul li.sched-past-time:hover {\n  background-color: var(--grey-300);\n  transform: none;\n}\n\n.sched-ul li.selected-slot {\n  background-color: var(--red-light); /* Highlight selected slot */\n  color: var(--clr-grey-1); /* Change text color for better contrast */\n  border: 2px solid var(--clr-primary-7); /* Add a more prominent border */\n}\n\n.sched-ul li.selected-slot:hover {\n  background-color: var(--clr-primary-4); /* Slightly darker highlight on hover */\n  transform: scale(1.1); /* Slightly larger scale for selected slot hover */\n}\n\n\n.schedule-hint {\n  font-size: 1rem;\n  color: var(--grey-6);\n  margin-bottom: 1rem;\n}\n\n.sched-slider {\n  margin-bottom: 1rem;\n  background-color: var(--grey-200);\n  padding: 0.5rem;\n  border-radius: var(--borderRadius);\n}\n\n.slick-prev,\n.slick-next {\n  background-color: var(--clr-primary-5) !important;\n  border-radius: 50% !important;\n  width: 30px !important;\n  height: 30px !important;\n  z-index: 1;\n}\n\n.slick-prev:before,\n.slick-next:before {\n  color: var(--clr-white) !important;\n  font-size: 20px !important;\n}\n\n.slick-prev:hover,\n.slick-next:hover {\n  background-color: var(--clr-primary-3) !important;\n}\n\n.slick-prev {\n  left: -40px !important;\n}\n\n.slick-next {\n  right: -40px !important;\n}\n\n.sched-slider-item {\n  text-align: center;\n  padding: 0.5rem;\n}\n\n.sched-day-button {\n  padding: 1rem 1.5rem; \n  border: 2px solid var(--clr-primary-5);\n  border-radius: var(--borderRadius);\n  background-color: var(--clr-primary-7);\n  color: var(--clr-white);\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  width: 100%;\n}\n\n.sched-day-button.disabled {\n  background-color: var(--grey-300);\n  color: var(--grey-600);\n  pointer-events: none;\n}\n\n.sched-day-button.today {\n  background-color: var(--clr-primary-6);\n  font-weight: bold;\n  color: var(--clr-white);\n}\n\n.sched-day-button.selected {\n  background-color: var(--red-light);\n  color: var(--clr-grey-1);\n}\n\n.sched-day-button:hover {\n  background-color: var(--clr-primary-3);\n  transform: scale(1.05); \n}\n\n.sched-proceed-button {\n  padding: 1.2rem 1.5rem; \n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n  border: none;\n  border-radius: var(--borderRadius);\n  font-size: 1.1rem; \n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.sched-proceed-button:hover {\n  background-color: var(--clr-primary-3);\n  transform: scale(1.05); \n}\n\n.sched-instructions {\n  font-size: 1rem;\n  color: var(--clr-grey-5);\n  margin-bottom: 1rem;\n  /* text-align: center; */\n}\n\n/* Fade-in and slide-up animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .sched-patient-view-container {\n    padding: 1.5rem;\n    /* margin: 2rem auto; */\n  }\n\n  .sched-slider-item {\n    padding: 0.3rem;\n  }\n\n  .sched-day-button {\n    padding: 0.8rem 1rem;\n    font-size: 1rem;\n  }\n\n  .sched-proceed-button {\n    font-size: 1rem;\n    padding: 1rem 1.2rem;\n  }\n}\n\n/* Styling for the recurring booking checkbox */\n.sched-recurring-checkbox {\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  color: var(--clr-primary-5);\n  font-weight: bold;\n}\n\n.sched-recurring-checkbox input {\n  margin-right: 10px;\n  transform: scale(1.2); \n  cursor: pointer; \n}\n\n/* Change cursor to 'not-allowed' when the checkbox is disabled */\n.sched-recurring-checkbox input:disabled {\n  cursor: not-allowed; \n}\n\n.sched-recurring-checkbox input:disabled + .checkbox-label {\n  color: var(--clr-grey-500); \n}\n\n.checkbox-label {\n  font-size: 1.1rem;\n  margin-right: 10px;\n  color: var(--clr-primary-7);\n}\n\n.sched-recurring-booking {\n  margin-top: 20px;\n  padding: 20px;\n  background-color: var(--grey-50);\n  border: 2px solid var(--clr-primary-5);\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-2); \n  transition: all 0.3s ease-in-out;\n}\n\n.sched-recurring-booking.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n/* Styling for recurring booking options */\n.sched-recurring-options {\n  margin-top: 15px;\n}\n\n.sched-recurring-label {\n  font-size: 1rem;\n  font-weight: bold;\n  color: var(--clr-primary-7);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sched-recurring-input {\n  margin-left: 0rem;\n  padding: 10px;\n  font-size: 1rem;\n  border-radius: var(--borderRadius);\n  border: 1px solid var(--grey-300);\n  background-color: var(--clr-white);\n  transition: border-color 0.3s ease;\n}\n\n.sched-recurring-input:focus {\n  border-color: var(--clr-primary-5);\n}\n\n.recurring-row {\n  margin-bottom: 15px;\n}\n\n.recurring-frequency {\n  margin-left: 10px;\n  font-weight: normal;\n  font-size: 0.9rem;\n  color: var(--grey-700);\n}\n\n.sched-recurring-select {\n  padding: 10px;\n  font-size: 1rem;\n  border-radius: var(--borderRadius);\n  border: 1px solid var(--grey-300);\n  background-color: var(--grey-50);\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.sched-recurring-select:hover,\n.sched-recurring-select:focus {\n  background-color: var(--clr-white);\n  border-color: var(--clr-primary-5);\n}\n\n/* Tooltip styling */\n.tooltip {\n  margin-left: 8px;\n  cursor: pointer;\n  font-size: 1.1rem;\n  color: #007BFF;\n  position: relative;\n}\n\n.tooltip:hover::after {\n  content: attr(title);\n  position: absolute;\n  left: 0;\n  bottom: 100%;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  padding: 5px;\n  border-radius: 4px;\n  white-space: nowrap;\n  z-index: 1;\n  color: var(--clr-primary-7);\n  font-size: 0.85rem;\n  box-shadow: var(--shadow-1);\n}\n\n/* Styling for the checkbox when it is disabled */\n.sched-recurring-checkbox input:checked:disabled {\n  cursor: not-allowed;\n  background-color: var(--clr-grey-300);\n}\n\n/* General input and button styles for consistency */\n.sched-recurring-input,\n.sched-recurring-select {\n  width: 100%;\n  margin-top: 5px;\n}\n\n.sched-recurring-options label {\n  display: block;\n  margin-bottom: 10px;\n}\n\n/* Hover effect for the recurring booking section */\n.sched-recurring-booking:hover {\n  background-color: var(--grey-100);\n  border-color: var(--clr-primary-6);\n  box-shadow: var(--shadow-3);\n}\n\n/* Custom Tooltip Styling */\n.custom-tooltip {\n  position: relative;\n  padding: 10px 15px;\n  background-color: var(--red-dark) ; \n  color: var(--clr-white); \n  font-size: 0.9rem;\n  border-radius: 5px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); \n  animation: fadeInTooltip 0.5s ease-out;\n  margin: 10px 0; \n  z-index: 10; \n  text-align: center; \n  /* max-width: 400px;  */\n  word-wrap: break-word; \n}\n\n/* Add tooltip arrow */\n.custom-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%; \n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: var(--red-light) transparent transparent transparent; /* Arrow pointing down */\n}\n\n/* Add subtle animation for the tooltip */\n@keyframes fadeInTooltip {\n  from {\n    opacity: 0;\n    transform: translateY(-10px); \n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Navigation Container - Text & Button  */\n.sched-view-navigation {\n  display: flex;\n  /* justify-content: center; */\n  align-items: center;\n  gap: 15px; /* Proper spacing between text and button */\n  margin-top: 3rem;\n  margin-bottom: 1rem;\n}\n\n/* Informational Text */\n.sched-text {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--clr-grey-1);\n  white-space: nowrap; \n}\n\n/* Previous Appointments Button  */\n.sched-view-button {\n  background: var(--clr-primary-5);\n  color: var(--clr-white);\n  padding: 12px 20px;\n  /* font-size: 16px; */\n  font-weight: bold;\n  border: none;\n  border-radius: var(--radius);\n  cursor: pointer;\n  transition: var(--transition);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: var(--shadow-2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -1rem;\n  /* min-width: 180px;  */\n}\n\n/* Hover & Active Effects */\n.sched-view-button:hover {\n  background: var(--clr-primary-3);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-3);\n}\n\n.sched-view-button:active {\n  transform: scale(0.98);\n}\n\n/* Responsive Fix: Stack Text & Button on Small Screens */\n@media screen and (max-width: 768px) {\n  .sched-view-navigation {\n      flex-direction: column;\n      text-align: center;\n  }\n\n  .sched-text {\n      margin-bottom: 8px;\n  }\n}\n\n\n/* Styles for clinic search section with alignment and responsiveness */\n.clinic-search-section {\n  margin: 0 auto 20px auto; \n  position: relative;\n  max-width: 100%; \n  display: flex;\n  flex-direction: column; \n}\n\n\n.clinic-search-section label {\n  display: block;\n  font-size: 1.1rem; \n  font-weight: bold;\n  color: var(--clr-primary-5);\n  margin-bottom: 8px; \n  text-align: left;\n}\n\n.clinic-search-input {\n  width: 100%;\n  padding: 12px; \n  border: 1px solid var(--grey-300);\n  border-radius: var(--borderRadius);\n  font-size: 1.1rem; \n  background-color: var(--grey-100);\n  transition: border-color 0.3s ease, background-color 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \n}\n\n.clinic-search-input:focus {\n  outline: none;\n  border-color: var(--clr-primary-5); \n  background-color: var(--clr-white);\n  box-shadow: 0 0 10px rgba(0, 123, 255, 0.2); \n}\n\n/* Clinic search results dropdown */\n.clinic-search-results {\n  margin-top: 10px;\n  border: 1px solid var(--grey-300);\n  border-radius: var(--borderRadius);\n  max-height: 250px; \n  overflow-y: auto; \n  background-color: var(--clr-white);\n  box-shadow: var(--shadow-3); \n  padding: 0; \n}\n\n/* Clinic search items */\n.clinic-search-item {\n  padding: 12px; \n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  font-size: 1rem;\n}\n\n.clinic-search-item:hover {\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n}\n\n.clinic-search-item.selected {\n  background-color: var(--clr-primary-7);\n  color: var(--clr-white);\n}\n\n.no-clinics-found {\n  margin-top: 10px;\n  font-size: 1rem;\n  color: var(--red-dark);\n  text-align: center; \n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .clinic-search-section {\n    max-width: 100%; \n  }\n\n  .clinic-search-item {\n    font-size: 0.9rem; \n    padding: 10px; \n  }\n\n  .clinic-search-results {\n    max-height: 200px; \n  }\n\n  .clinic-search-input {\n    padding: 10px; \n    font-size: 1rem;\n  }\n}\n\n.no-doctors-banner {\n  background-color: #f8d7da; \n  color: #721c24; \n  padding: 10px;\n  margin-top: 10px;\n  border: 1px solid #f5c6cb; \n  border-radius: 5px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.booked-slot-info {\n  margin: 1rem 0;\n  padding: 1rem;\n  background-color: var(--grey-300); \n  border-left: 4px solid var(--clr-grey-3); \n  /* color: var(--red-light); */\n  border-radius: 4px;\n}\n\n.booked-slot-info h4 {\n  margin: 0 0 0.5rem;\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.booked-slot-info ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.booked-slot-info ul li {\n  font-size: 0.9rem;\n}\n\n.info-display-container {\n  padding: 2rem;\n  background-color: var(--grey-50); \n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-2); \n  font-size: 1rem;\n  color: var(--textColor); \n  animation: slideUp 0.8s ease-out; \n}\n\n/* .info-display-container h2 {\n  font-size: 1.4rem;\n  color: var(--clr-primary-5); \n  margin-bottom: 1rem;\n} */\n\n.info-display-container ul {\n  margin: 0;\n  padding: 0;\n  list-style-type: disc; \n  margin-left: 1.5rem; \n}\n\n.info-display-container li {\n  margin-bottom: 0.8rem;\n}\n\n@media (max-width: 768px) {\n  .patient-view-layout {\n    grid-template-columns: 1fr; \n  }\n\n  .sched-patient-view-container,\n  .info-display-container {\n    padding: 1.5rem; \n  }\n}\n\n/* Timeline Container */\n.vertical-timeline-container {\n  /* max-width: 600px; */\n  margin: 2rem auto;\n  padding: 1.5rem;\n  background-color: var(--clr-white);\n  border: 1px solid var(--grey-300);\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-2);\n}\n\n.timeline-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: var(--clr-primary-7);\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n/* Vertical Timeline */\n.vertical-timeline {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n}\n\n/* Step Styling */\n.timeline-step {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n  position: relative;\n}\n\n.timeline-marker {\n  width: 40px;\n  height: 40px;\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.2rem;\n  font-weight: bold;\n  z-index: 1;\n  flex-shrink: 0;\n}\n\n.timeline-content {\n  margin-left: 1.5rem;\n  text-align: left;\n}\n\n.timeline-step-title {\n  font-size: 1.1rem;\n  font-weight: bold;\n  color: var(--clr-grey-5);\n  margin-bottom: 0.5rem;\n}\n\n.timeline-step-description {\n  font-size: 0.9rem;\n  color: var(--clr-grey-2);\n  line-height: 1.4;\n}\n\n\n/* Responsive Styling */\n@media (max-width: 768px) {\n  .vertical-timeline-container {\n    padding: 1rem;\n  }\n\n  .timeline-title {\n    font-size: 1.3rem;\n  }\n\n  .timeline-marker {\n    width: 30px;\n    height: 30px;\n    font-size: 1rem;\n  }\n\n  .timeline-content {\n    margin-left: 1rem;\n  }\n\n  .timeline-step-title {\n    font-size: 1rem;\n  }\n\n  .timeline-step-description {\n    font-size: 0.85rem;\n  }\n}\n\n\n\n/* Practitioner List Container */\n/* .info-practitioner-list {\n  margin-top: 2rem;\n  text-align: left;\n} */\n/* Section 2 - Practitioner List */\n.info-practitioner-list {\n  padding: 2rem;\n  background-color: var(--clr-white);\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-1);\n  border: 2px solid var(--clr-primary-3); \n}\n\n.info-practitioner-title {\n  font-size: 1.2rem; \n  color: var(--clr-primary-5);\n  margin-bottom: 1rem;\n  font-weight: bold;\n}\n\n/* Practitioner Cards Grid */\n.info-practitioner-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); \n  gap: 1rem; \n}\n\n/* Practitioner Card */\n.info-practitioner-card {\n  background-color: var(--clr-white);\n  border: 1px solid var(--grey-300);\n  border-radius: var(--borderRadius);\n  padding: 0.8rem;\n  box-shadow: var(--shadow-1);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; \n  align-items: center;\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n\n  /* Added height properties */\n  min-height: 250px; \n  height: auto; \n  max-height: 400px; \n}\n\n.info-practitioner-card:hover {\n  transform: scale(1);\n  box-shadow: var(--shadow-3);\n}\n\n/* Practitioner Image */\n.info-practitioner-image {\n  width: 5rem !important; \n  height: 5rem;\n  border-radius: 50%;\n  margin-bottom: 0.5rem;\n  object-fit: cover; \n}\n\n/* Practitioner Details */\n.info-practitioner-details {\n  width: 100%; \n  margin-top: auto; \n  font-size: 0.85rem; \n}\n\n/* Practitioner Row */\n.info-practitioner-row {\n  display: flex;\n  align-items: center; \n  justify-content: space-between; \n  gap: 1rem; \n  font-size: 0.9rem; \n  color: var(--clr-grey-7); \n}\n\n/* Individual Fields */\n.info-practitioner-specialization,\n.info-practitioner-license {\n  margin: 0; \n  white-space: nowrap; \n  overflow: hidden; \n  text-overflow: ellipsis; \n  color: var(--clr-grey-2);\n}\n\n/* Practitioner Header */\n.info-practitioner-header {\n  display: flex;\n  align-items: center; \n  justify-content: space-between; \n  gap: 1rem; \n  font-size: 1rem; \n  color: var(--clr-grey-9); \n}\n\n/* Name Field */\n.info-practitioner-name {\n  font-size: 1rem; \n  font-weight: bold; \n  margin: 0; \n  /* flex-grow: 1;  */\n  white-space: nowrap; \n  overflow: hidden; \n  text-overflow: ellipsis; \n  color: var(--clr-accent);\n}\n\n/* Phone Field */\n.info-practitioner-phone {\n  font-size: 0.9rem; \n  margin: 0; \n  white-space: nowrap; \n  color: var(--clr-grey-1); \n}\n\n/* No Practitioners Placeholder */\n.info-no-practitioners {\n  font-size: 0.9rem;\n  color: var(--red-light);\n  text-align: center;\n}\n\n/* Default Placeholder Message */\n.info-default-message {\n  font-size: 0.9rem;\n  color: var(--clr-grey-7);\n  text-align: center;\n  padding: 1rem;\n  background-color: var(--grey-50);\n  border-radius: var(--borderRadius);\n  border: 1px dashed var(--clr-primary-5);\n  animation: fadeIn 0.6s ease;\n}\n\n/* Scrollable Container */\n.scrollable-container {\n  max-height: 30rem; \n  overflow-y: auto;\n  padding-right: 0.5rem;\n}\n\n.scrollable-container::-webkit-scrollbar {\n  width: 0.4rem;\n}\n\n.scrollable-container::-webkit-scrollbar-thumb {\n  background-color: var(--clr-primary-5);\n  border-radius: var(--borderRadius);\n}\n\n.scrollable-container::-webkit-scrollbar-thumb:hover {\n  background-color: var(--clr-primary-7);\n}\n\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  /* Adjust card grid for smaller screens */\n  .info-practitioner-cards {\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 0.8rem; /* Reduced gap */\n  }\n\n  /* Practitioner Card */\n  .info-practitioner-card {\n    padding: 0.6rem; \n  }\n\n  .info-practitioner-image {\n    width: 4rem;\n    height: 4rem; \n  }\n\n  .info-practitioner-details {\n    font-size: 0.75rem; \n  }\n\n  .info-practitioner-name {\n    font-size: 0.85rem;\n  }\n\n  /* Adjust Scrollable Height */\n  .scrollable-container {\n    max-height: 15rem;\n  }\n}\n\n@media (max-width: 480px) {\n  /* Single Column for Very Small Screens */\n  .info-practitioner-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .info-practitioner-image {\n    width: 3.5rem;\n    height: 3.5rem; \n  }\n\n  .info-practitioner-name {\n    font-size: 0.8rem;\n  }\n\n  .info-practitioner-details {\n    font-size: 0.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
